import React, { useEffect } from "react";
import ServiceHero from "../../Components/ServicePageComponents/ServiceHero";
import CommonContact from "../../Components/ContactPageComponents/CommonContact";
import ProvidedServicesM2 from "../../Components/ServicePageComponents/ProvidedServicesM2";
import providedservies1 from "../../Components/images/providedEcom-img1.png";
import providedservies2 from "../../Components/images/providedEcom-img2.png";
import providedservies3 from "../../Components/images/providedEcom-img3.png";
import Process from "../../Components/ServicePageComponents/Process";
import img1 from "./images/web.png"
import img2 from "./images/payment.png"
import img3 from "./images/logistics.png"

export default function EcommerceSolution() {
  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to top when the component is mounted
  }, []);
  const processes = [
    {
      img: img1,
      title: "E-commerce Website Design and Development",
    },
    {
      img: img2,
      title: "Payment Gateway Integration",
    },
    {
      img: img3,
      title: "Shipping and Logistics Setup",
    },
  ];
  return (
    <div>
      <ServiceHero
        title={
          "Transforming Your Business with E-commerce Website Design and Development"
        }
        para={
          "Zenhook offers innovative e-commerce website design and development to drive business growth. Our solutions improve efficiency, streamline processes, and enhance online store performance. we help businesses succeed in the competitive e-commerce market."
        }
      />
      {/* passing process as props */}
      <Process processes={processes}/>
      <ProvidedServicesM2
        title={"E-commerce Website Setup"}
        des={
          "This involves creating an online store that is visually appealing, user-friendly, and optimized for conversion. The design should reflect the brand’s identity while ensuring a seamless shopping experience. Development includes building the site’s structure, functionality, and integrating essential features like product catalogs and checkout systems."
        }
        imageSrc={providedservies1}
        mobileimage={providedservies1}
        w={'425px'}
        h={'480px'}
        reverse={false}
      />
      <ProvidedServicesM2
        title={"Digital Marketing"}
        des={
          "Integrating social media and email marketing tools with your e-commerce site boosts engagement by allowing product sharing and targeted email campaigns. Proper product setup, including detailed listings and SEO optimization, Digital advertising through platforms like Google and Facebook helps drive traffic by targeting specific customer behaviors and interests, increasing brand visibility and sales."
        }
        imageSrc={providedservies2}
        mobileimage={providedservies2}
        w={'445px'}
        h={'519px'}
        reverse={true}
      />
      <ProvidedServicesM2
        title={"Maintenance and Technical Support"}
        des={
          "Regular maintenance is required to keep the website running smoothly. This includes updating software, fixing bugs, and ensuring that security protocols are up to date. Technical support helps resolve any issues that arise, providing a seamless experience for users and business owners alike."
        }
        imageSrc={providedservies3}
        mobileimage={providedservies3}
        w={'445px'}
        h={'519px'}
        reverse={false}
      />
      <CommonContact />
    </div>
  );
}
